var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.community'] = (function () {
    'use strict';

    const initialize = (widget) => {
        App.ZagParallax.initialize('.community', '.community__bg', { divisor: 1.25 });
        
        const numbers = widget.querySelectorAll('.statistic__number');
        const odometers = Array.from(numbers).map((number) => new Odometer({
            el: number,
            value: number.dataset.start,
            endValue: number.dataset.end,
            format: '(,ddd)',
            theme: 'minimal',
            duration: 2500
        }));

        if (odometers.length > 0) {
            const updateOdometers = () => {
                odometers.forEach((odometer) => {
                    odometer.update(odometer.options.endValue);
                });
            };

            if ('IntersectionObserver' in window) {
                const observer = new IntersectionObserver(([entry]) => {
                    if (entry.isIntersecting) {
                        updateOdometers();
                        observer.disconnect();
                    }
                }, {
                    threshold: 0.1,
                    rootMargin: '0px'
                });

                observer.observe(widget);
            } else {
                updateOdometers();
            }
        }

        const carouselEl = widget.querySelector(".splide");
        if (!carouselEl) return;

        const splideOptions = {
            type: "fade",
            //focus: "center",
            rewind: true,
            pagination: false,
            arrows: false,
            noDrag: true,
            interval: 3000,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            resetProgress: false,
            drag: false,
        };

        App.Helpers.splideFallback(
            carouselEl,
            splideOptions,
            (splide) => {
                splideEventBindings(splide, carouselEl, widget);
            }
        );
    };

    const splideEventBindings = (splide, carouselEl, widget) => {

        const controls = widget.querySelector(".community__slideshow-controls");
        if (!controls) return;

        splide.on("mounted", () => {
            const playButton = controls.querySelector(".community__slideshow-play");
            const pauseButton = controls.querySelector(".community__slideshow-pause");

            playButton?.addEventListener("click", () => play(splide, controls));
            pauseButton?.addEventListener("click", () => pause(splide, controls));
        });
    };

    const play = (splide, controls) => {
        controls.querySelector(".community__slideshow-play").setAttribute("aria-pressed", "true");
        controls.querySelector(".community__slideshow-pause").setAttribute("aria-pressed", "false");
        controls.querySelector(".community__slideshow-play").classList.add("d-none");
        controls.querySelector(".community__slideshow-pause").classList.remove("d-none");
        splide.Components.Autoplay.play();
    };

    const pause = (splide, controls) => {
        controls.querySelector(".community__slideshow-play").setAttribute("aria-pressed", "false");
        controls.querySelector(".community__slideshow-pause").setAttribute("aria-pressed", "true");
        controls.querySelector(".community__slideshow-play").classList.remove("d-none");
        controls.querySelector(".community__slideshow-pause").classList.add("d-none");
        splide.Components.Autoplay.pause();
    };

    return {
        initialize
    };

})();